import styled from 'styled-components'

export const StyledSetupContentContainer = styled.div`
  padding: 10px 25px;
  min-width: 470px;
`
